import { Dokument } from './dokument';
import { BaseDataService, TabsContainerService, UserService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { BaseTabsUpdateComponent } from 'yt-ng-framework';

@Component({
  selector: 'yt-dokument-tab-update',
  templateUrl: './dokument-tab-update.component.html',
})
export class DokumentTabUpdateComponent extends BaseTabsUpdateComponent<Dokument> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected tabsContainerService: TabsContainerService<Dokument>,
    protected baseDataService: BaseDataService,
    protected userService: UserService
  ) {
    super(activatedRoute, tabsContainerService, baseDataService, userService);
  }


  ngOnInit() {
    super.ngOnInit();
  }

  //AddItem(){}
  

}
